import { ORDER_FULFILLMENT_STATUSES } from '../../../../../services/exports/Constants';

export default {
  title: '{{orderMethod}} estimada: {{day}} alrededor de las {{time}}',
  status: {
    [ORDER_FULFILLMENT_STATUSES.REJECTED]: {
      title: 'Pedido rechazado',
    },
    [ORDER_FULFILLMENT_STATUSES.CREATED]: {
      title: 'Pedido recibido',
    },
    [ORDER_FULFILLMENT_STATUSES.REVIEWED]: {
      title: 'Tu pedido ha sido visto',
    },
    [ORDER_FULFILLMENT_STATUSES.ACCEPTED]: {
      title: 'Pedido confirmado',
    },
    [ORDER_FULFILLMENT_STATUSES.READY]: {
      title: 'Pedido listo',
    },
    [ORDER_FULFILLMENT_STATUSES.ON_DELIVERY]: {
      title: 'Pedido en camino',
    },
    [ORDER_FULFILLMENT_STATUSES.PICKED]: {
      title: 'Pedido completado',
    },
  },
  labels: {
    today: 'Hoy',
  },
  waiting_confirmation: {
    title: 'Esperando confirmación del pedido',
    description: 'Un momento...',
  },
  pickup_time: {
    title: 'Hora de recogida',
    description: 'Confirmado por {{name}}',
  },
  delivery_time: {
    title: 'Hora de entrega',
    description: 'Confirmado por {{name}}',
  },
  warning_label: {
    pickup_time_changed: '{{company}} cambió la hora de {{initialTime}} a {{currentTime}}',
  },
};
